import { use } from 'react';

import { MapInteractionCommandsContext, type MapInteractionCommands } from './MapInteractionContext';

/**
 * Frozen no-op fallback for use outside a <MapInteractionProvider> — UNIT TESTS
 * ONLY (matching the useExclusivePanel / useTableView convention). Every production
 * route that renders MapView mounts the provider; the route tests for Find & Fix
 * and SAVI prove both production arrangements, so a silently-inert map is a
 * test-harness situation, never a shipped one.
 */
const NOOP_COMMANDS: MapInteractionCommands = Object.freeze({
    selectPoi: () => {},
    showPoiDetails: () => {},
    selectLeak: () => {},
    selectVan: () => {},
    selectArea: () => {},
    selectDma: () => {},
    locatePoi: () => {},
    locateArea: () => {},
    locateDma: () => {},
    clearSelection: () => {},
    emptyMapClick: () => {},
    panelOpened: () => {},
    tableClosed: () => {},
    searchCleared: () => {},
    resetToNetwork: () => {},
    activateTool: () => {},
    deactivateTool: () => {},
});

/** Commands that mutate the map-interaction slice. Referentially stable inside a provider. */
export function useMapInteractionCommands(): MapInteractionCommands {
    return use(MapInteractionCommandsContext) ?? NOOP_COMMANDS;
}
